// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1E4vF","location":"Header_location__1QGN2"};